// https://drafts.csswg.org/css-cascade-5/
export const cssWideKeywords = [
    'initial',
    'inherit',
    'unset',
    'revert',
    'revert-layer'
];
